import { UserOutlined } from '@ant-design/icons';
import breakpoints from 'constants/breakpoints';
import styled from 'styled-components';
import Widget from 'Wieldly/components/Widget';

export const UserAvatarContainerStyled = styled.div<{ $isMobile?: boolean }>`
  & .ant-carousel {
    height: 100%;
  }
  & .gx-data-card-carousel {
    height: 100%;
    ${({ $isMobile }) => ($isMobile ? 'overflow: hidden' : '')}
  }
`;

export const UserInfoContainerStyled = styled.div`
  overflow: hidden;
`;

export const UserInfoTextStyled = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ActionButtonContainer = styled.div<{ $iconOnHoverColor?: string; $activeColor?: string }>`
  cursor: pointer;
  text-align: center;
  i {
    transition: 0.25s color;
    &:hover {
      ${({ $iconOnHoverColor }) => ($iconOnHoverColor ? `color: ${$iconOnHoverColor} !important` : '')};
    }
  }

  &:hover i {
    transition: 0.3s color;
    color: ${({ $iconOnHoverColor }) => `${$iconOnHoverColor} !important` || 'inherit'};
  }
`;

export const WidgetStyled = styled(Widget)<{ $height?: string; $width?: string }>`
  background: #fafafa;
  height: ${({ $height }) => $height || 'auto'};
  width: ${({ $width }) => $width || 'auto'};
  & .ant-card-body {
    height: 100%;
    & .gx-user-wid-row {
      height: 100%;
    }
  }
  @media screen and (max-width: ${breakpoints.xs}) {
    max-width: 100%;
  }
`;

export const CarouselImageContainerStyled = styled.a`
  background: #364d79;
  display: block;
`;

export const StaticImageContainerStyled = styled.div<{ $height?: string }>`
  height: ${({ $height }) => $height || 'auto'};
  width: 100%;
  background: #364d79;
`;

export const CarouselImageStyled = styled.img`
  object-fit: cover !important;
  position: relative !important;
`;

export const CardStatus = styled.div<{ $statusTooltipColor?: string }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  top: 20px;
  right: 13px;
  position: absolute;
  background: ${({ $statusTooltipColor = 'black' }) => $statusTooltipColor};
`;

export const FullSizeUserOutline = styled(UserOutlined)`
  width: 100%;
  height: 100%;
  & svg {
    width: 100%;
    height: 100%;
  }
`;

export const MainTextStyled = styled.span`
  font-size: 18px;
  line-height: 1.25;
`;
